export const AssemblyFormValidation = (assembly_data, validateFields) => {
    const validateFieldsCopy = { ...validateFields };
    let isAnyEmptyFields = false;

    if (!assembly_data?.assembly_number?.trim()) {
      validateFieldsCopy.assembly_number = 'Please add Assembly #';
      isAnyEmptyFields = true;
    } else {
      validateFieldsCopy.assembly_number = '';
    }

    if (!assembly_data?.assembly_type?.trim()) {
      validateFieldsCopy.assembly_type = 'Please add Assembly Type';
      isAnyEmptyFields = true;
    } else {
      validateFieldsCopy.assembly_type = '';
    }

    return [isAnyEmptyFields, validateFieldsCopy];
};
